import { Controller } from '@hotwired/stimulus'
import Modal from 'components/modal'

export default class extends Controller {
  initialize() {
    const targetQuestionSelector = this.element.dataset.targetQuestionSelector
    const targetQuestion = document.querySelector(targetQuestionSelector)

    if (!targetQuestionSelector) {
      throw (`Please provide a data-target-question-selector to the QuizQuestionModalNavButton controller`)
    } else if (!targetQuestion) {
      throw (`Unable to find target question with selector: ${targetQuestionSelector}`)
    } else {
      this.element.addEventListener("click", (e) => {
        e.preventDefault()
        targetQuestion.click()
      })
    }
  }
}
